// extracted by mini-css-extract-plugin
export default {"footer":"BrandingFooter_footer__LP0iM","link":"BrandingFooter_link__etLg9","icon":"BrandingFooter_icon__QG9DK"};